module.exports = __webpack_public_path__ + "img/26-OUQ.6f66779.jpg";